import React, { useState } from "react";
import { LicenseUpgradeService } from "../../utils/Services";
import { UpgradeLicenseContactFormRequest, UpgradeLicenseContactFormResponse } from "../../models/UpgradeLicenseModel";
import sendImg from "../../../img/upgrade/send.svg";

interface UpgradeContactForm {
    license: string;
    wasEligible: boolean;
    onSuccess: (email: string) => void;
    onError: () => void;
}

const jobTitles = ["", "CEO", "CTO/CIO", "System Architect", "Director of IT", "Software Developer", "Other"];
const countries =
    "|Afghanistan|Albania|Algeria|American Samoa|Andorra|Angola|Anguilla|Antarctica|Antigua and Barbuda|Argentina|Armenia|Aruban|Australia|Austria|Azerbaijan|Bahamas|Bahrain|Bangladesh|Barbados|Belarus|Belgium|Belize|Benin|Bermuda|Bhutan|Bolivia|Bosnia and Herzegovina|Botswana|Bouvet Island|Brazil|British Indian Ocean Territory|British Virgin Islands|Brunei|Bulgaria|Burkina Faso|Burundi|Cambodia|Cameroon|Canada|Cape Verde|Cayman Islands|Central African Republic|Chad|Chile|China|Christmas Island|Cocos Islands|Colombia|Comoros|Republic of the Congo|Cook Islands|Costa Rica|Croatia|Cuba|Cyprus|Czech Republic|Cote d'Ivoire|Denmark|Djibouti|Dominica|Dominican Republic|Ecuador|Egypt|El Salvador|Equatorial Guinea|Eritrea|Estonia|Ethiopia|Falkland Islands|Faroe Islands|Fiji|Finland|France|French Guiana|French Polynesia|French Southern Territories|Gabon|Gambia|Georgia|Germany|Ghana|Gibraltar|Greece|Greenland|Grenada|Guadeloupe|Guam|Guatemala|Guernsey|Guinea|GuineaBissau|Guyana|Haiti|Heard Island and McDonald Islands|Honduras|Hong Kong|Hungary|Iceland|India|Indonesia|Iran|Iraq|Ireland|Israel|Italy|Jamaica|Japan|Jersey|Jordan|Kazakhstan|Kenya|Kiribati|Kosovo|Kuwait|Kyrgyzstan|Laos|Latvia|Lebanon|Lesotho|Liberia|Libya|Liechtenstein|Lithuania|Luxembourg|Macao|North Macedonia|Madagascar|Malawi|Malaysia|Maldives|Mali|Malta|Marshall Islands|Martinique|Mauritania|Mauritius|Mayotte|Mexico|Micronesia|Moldova|Monaco|Mongolia|Montenegro|Montserrat|Morocco|Mozambique|Myanmar|Namibia|Nauru|Nepal|Netherlands|Netherlands Antilles|New Caledonia|New Zealand|Nicaragua|Niger|Nigeria|Niue|Norfolk Island|North Korea|Northern Ireland|Northern Mariana Islands|Norway|Oman|Pakistan|Palau|Palestine|Panama|Papua New Guinea|Paraguay|Peru|Philippines|Pitcairn|Poland|Portugal|Puerto Rico|Qatar|Reunion|Romania|Russia|Rwanda|Saint Helena|Saint Kitts and Nevis|Saint Lucia|Saint Pierre and Miquelon|Saint Vincent and the Grenadines|Samoa|San Marino|Sao Tome and Principe|Saudi Arabia|Senegal|Serbia|Serbia and Montenegro|Seychelles|Sierra Leone|Singapore|Slovakia|Slovenia|Solomon Islands|Somalia|South Africa|South Georgia and the South Sandwich Islands|South Korea|Spain|Sri Lanka|Sudan|Suriname|Svalbard and Jan Mayen|Eswatini|Sweden|Switzerland|Syria|Taiwan|Tajikistan|Tanzania|Thailand|Democratic Republic of the Congo|Timor-Leste|Togo|Tokelau|Tonga|Trinidad and Tobago|Tunisia|Turkey|Turkmenistan|Turks and Caicos Islands|Tuvalu|Virgin Islands|Uganda|Ukraine|United Arab Emirates|United Kingdom|United States|United States Minor Outlying Islands|Uruguay|Uzbekistan|Vanuatu|Vatican|Venezuela|Vietnam|Wallis and Futuna|Western Sahara|Yemen|Zambia|Zimbabwe|Aland Islands".split(
        "|"
    );

const licenseUpgradeService = new LicenseUpgradeService();

export function UpgradeContactForm(props: UpgradeContactForm) {
    const { license, onSuccess, onError } = props;
    const [email, setEmail] = useState<string>("");
    const [firstName, setFirstName] = useState<string>("");
    const [lastName, setLastName] = useState<string>("");
    const [phone, setPhone] = useState<string>("");
    const [jobTitle, setJobTitle] = useState<string>("");
    const [country, setCountry] = useState<string>("country");
    
    const onSubmit = async (e: any) => {
        e.preventDefault();

        const dto: UpgradeLicenseContactFormRequest = {
            email,
            firstName,
            lastName,
            phone,
            jobTitle,
            country,
            license,
        };

        const response = await licenseUpgradeService.contactForm(dto);
        
        if (response.status === "Success") {
            onSuccess(email);
        } else if (response.status === "Invalid") {
            onError();
        }
    };
    
    return (
        <form method="post" onSubmit={onSubmit} className="vstack gap-4">
            <div className="row">
                <div className="col-12 mb-3">
                    <label htmlFor="email" className="form-label">
                        E-mail *
                    </label>
                    <input
                        className="form-control"
                        type="email"
                        id="email"
                        name="email"
                        required
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                </div>

                <div className="col-12 col-sm-6 mb-3">
                    <label htmlFor="firstName" className="form-label">
                        First name *
                    </label>
                    <input
                        className="form-control"
                        id="firstName"
                        name="firstName"
                        required
                        value={firstName}
                        onChange={(e) => setFirstName(e.target.value)}
                    />
                </div>

                <div className="col-12 col-sm-6 mb-3">
                    <label htmlFor="lastName" className="form-label">
                        Last name *
                    </label>
                    <input
                        className="form-control"
                        id="lastName"
                        name="lastName"
                        required
                        value={lastName}
                        onChange={(e) => setLastName(e.target.value)}
                    />
                </div>
                <div className="col-12 col-sm-6 mb-3">
                    <label htmlFor="phone" className="form-label">
                        Phone
                    </label>
                    <input
                        className="form-control"
                        id="phone"
                        name="phone"
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                    />
                </div>
                <div className="col-12 col-sm-6 mb-3">
                    <label htmlFor="title" className="form-label">
                        Job title *
                    </label>
                    <select
                        className="form-control"
                        id="jobTitle"
                        name="jobTitle"
                        required
                        value={jobTitle}
                        onChange={(e) => setJobTitle(e.target.value)}
                    >
                        {jobTitles.map((title) => (
                            <option key={title} value={title}>
                                {title}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="col-12 mb-3">
                    <label htmlFor="country" className="form-label">
                        Country *
                    </label>
                    <select
                        className="form-control"
                        id="country"
                        name="country"
                        required
                        value={country}
                        onChange={(e) => setCountry(e.target.value)}
                    >
                        {countries.map((country) => (
                            <option key={country} value={country}>
                                {country}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
            <button
                type="submit"
                className="btn btn-primary rounded-pill text-white btn-lg px-5 py-2 align-self-center d-flex align-items-center gap-2"
            >
                <img alt="" src={sendImg} className="image-size" /> Submit
            </button>
        </form>
    );
}
